import {makeAutoObservable} from "mobx";
import AdvImgType from "enum/AdvImgType";

class HomeAdvStore {

    loading = true;
    adv1 = undefined
    adv2 = undefined

    setData({list}) {
        this.adv1 = list.find(item => item.type === AdvImgType.web_home_adv_1)
        this.adv2 = list.find(item => item.type === AdvImgType.web_home_adv_2)
        this.loading = false
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default HomeAdvStore;